import { render, staticRenderFns } from "./leaveRequestsDetails.vue?vue&type=template&id=a1c99908&scoped=true&"
import script from "./leaveRequestsDetails.vue?vue&type=script&lang=js&"
export * from "./leaveRequestsDetails.vue?vue&type=script&lang=js&"
import style0 from "./leaveRequestsDetails.vue?vue&type=style&index=0&id=a1c99908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c99908",
  null
  
)

export default component.exports